/**
 * @file 编辑器默认配置
 * @author jiaojian04
 */


export default {
    'document_base_url': 'https://smartprogram.baidu.com',
    'height': 240,
    // 隐藏menu
    'menu': {},
    'branding': false,
    // 皮肤通过上面import css的方式已经引入过了
    'skin': false,
    'plugins': 'textcolor paste codesample lists link forumImgUpload',
    'content_style': '.mce-content-body {font-size: 14px;}',
    // 可选的字号
    'fontsize_formats': '12px 14px 16px 18px 20px',
    'toolbar': 'fontsizeselect'
        + ' forecolor'
        + ' backcolor'
        + ' formatselect'
        + ' bold'
        + ' italic'
        + ' underline'
        + ' alignleft'
        + ' aligncenter'
        + ' alignright'
        + ' alignjustify'
        + ' indent'
        + ' outdent'
        + ' bullist'
        + ' numlist'
        + ' link'
        + ' blockquote'
        + ' codesample'
        + ' forumImgUpload',
    'menubar': 'insert',
    // 去除tag,只允许粘贴纯文本，防止发帖者发动攻击
    'paste_as_text': true,
    // 粘贴图片，与粘贴纯文本不能共存
    // 'paste_data_images': true,
    // 默认链接在新窗口打开
    'default_link_target': '_blank',
    // 不显示链接title选项
    'link_title': false,
    // 不显示target选项
    'target_list': false,
    // 检查链接是否带http前缀
    'link_assume_external_targets': true,
    // 引入prism语法高亮皮肤
    'codesample_content_css': 'https://b.bdstatic.com/miniapp/assets/css/prism.min.css',
    // 有序只能选择数字
    'advlist_number_styles': '',
    // 无序li只能选择圆圈
    'advlist_bullet_styles': '',
    'codesample_languages': [
        {text: 'JavaScript', value: 'javascript'},
        {text: 'PHP', value: 'php'},
        {text: 'Ruby', value: 'ruby'},
        {text: 'Python', value: 'python'},
        {text: 'Java', value: 'java'},
        {text: 'C', value: 'c'},
        {text: 'C#', value: 'csharp'},
        {text: 'C++', value: 'cpp'}
    ]
};
